var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSismoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,239.83A111.83,111.83,0,1,1,239.83,128,111.95,111.95,0,0,1,128,239.83ZM128,20.4A107.6,107.6,0,1,0,235.61,128,106.93,106.93,0,0,0,128,20.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.08,219.14H135a2.08,2.08,0,0,1-2-1.93L121.35,65.31,105.69,169.88a2.09,2.09,0,0,1-2.07,1.78h0a2.09,2.09,0,0,1-2.07-1.79l-8.67-59.15-9.21,32.7a2.08,2.08,0,0,1-2,1.53h0a2.11,2.11,0,0,1-2-1.54l-6-21.55-3.11,8.64a2.09,2.09,0,0,1-2,1.39H36a2.1,2.1,0,0,1,0-4.19H67.13L72,114.25a2.05,2.05,0,0,1,2-1.38A2.08,2.08,0,0,1,76,114.4l5.72,20.68,9.84-34.93a2.09,2.09,0,0,1,4.08.26l8,54.88L120,46.39a2,2,0,0,1,2.15-1.78,2.09,2.09,0,0,1,2,1.93l11.48,149.83L149,90.36a2.13,2.13,0,0,1,2.11-1.83,2.1,2.1,0,0,1,2.05,1.89l5.52,58.2,9.38-31.3a2.11,2.11,0,0,1,2-1.49h0a2.11,2.11,0,0,1,2,1.47l7.1,22.83,10.6-14a2.12,2.12,0,0,1,1.67-.83h30.86a2.09,2.09,0,1,1,0,4.18H192.51L180.08,145.9a2.09,2.09,0,0,1-3.67-.64l-6.28-20.18-10.49,35a2.09,2.09,0,0,1-4.09-.41l-4.74-50L137.16,217.31A2.1,2.1,0,0,1,135.08,219.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.86,146.77a17.62,17.62,0,1,1,17.61-17.62A17.63,17.63,0,0,1,125.86,146.77Zm0-33.84a16.22,16.22,0,1,0,16.21,16.22A16.24,16.24,0,0,0,125.86,112.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.86,159.68a30.53,30.53,0,1,1,30.52-30.53A30.56,30.56,0,0,1,125.86,159.68Zm0-59.66A29.13,29.13,0,1,0,155,129.15,29.16,29.16,0,0,0,125.86,100Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.86,190.21a61.06,61.06,0,1,1,61.05-61.06A61.13,61.13,0,0,1,125.86,190.21Zm0-120.72a59.66,59.66,0,1,0,59.65,59.66A59.73,59.73,0,0,0,125.86,69.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.86,208.75a79.6,79.6,0,1,1,79.59-79.6A79.69,79.69,0,0,1,125.86,208.75Zm0-157.79a78.2,78.2,0,1,0,78.19,78.19A78.28,78.28,0,0,0,125.86,51Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.86,174.46a45.31,45.31,0,1,1,45.3-45.31A45.35,45.35,0,0,1,125.86,174.46Zm0-89.22a43.91,43.91,0,1,0,43.91,43.91A44,44,0,0,0,125.86,85.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSismoIcon);
export default __webpack_public_path__ + "static/media/SismoIcon.d021d4e6e4ae39f958197630c1bb7bb5.svg";
export { ForwardRef as ReactComponent };